module.exports = __webpack_public_path__ + "img/49.7764a845.png";